/**
 * spCredsReadiness — are BOTH dedicated-Service-Principal credentials set for
 * the current user (epic-sp-login-email + epic-sp-login)?
 *
 * The readiness half of the retired `SpCredentialReset` editor (story 28633:
 * deleted — it only served Carrier Mortgagee Update v1.2's per-user SP, now
 * unpublished; Mortgagee Change uses the admin-managed shared pool, and "Use
 * my own Epic login" asks for the AM's credentials inside the run). The launch
 * drawer still asks this question for a v1.2 relaunch so it can block a launch
 * that would stop at once with `sp_credentials_missing`.
 *
 * Errors report not-ready (fail closed, matching the launch gate).
 */
import { orchestratorApi } from "../services/orchestratorApi";

const SP_EMAIL_CRED = "epic-sp-login-email";
const SP_PASSWORD_CRED = "epic-sp-login";

export async function fetchSpCredsReady(): Promise<boolean> {
  try {
    const statuses = await orchestratorApi.getMyCredentialStatus();
    const pwd = statuses.find((s) => s.credential_name === SP_PASSWORD_CRED);
    const mail = statuses.find((s) => s.credential_name === SP_EMAIL_CRED);
    return pwd?.status === "set" && mail?.status === "set";
  } catch {
    return false;
  }
}
